/** Snapshot sintético usado somente pela entrada de desenvolvimento. */
export const BOSS_FINAL_DEMO_INSIGHTS = Object.freeze([
    ['demo-01', 'GRUPO 1', 'Escutar o cliente antes de apresentar a tecnologia transforma a conversa.'],
    ['demo-02', 'GRUPO 2', 'Conectar cada detalhe do carro a uma necessidade real torna a experiência mais relevante.'],
    ['demo-03', 'GRUPO 3', 'A confiança cresce quando produto e atendimento contam a mesma história.'],
    ['demo-04', 'GRUPO 4', 'Uma boa pergunta revela o que realmente importa para cada cliente.'],
    ['demo-05', 'GRUPO 5', 'Tecnologia ganha valor quando seu benefício fica simples de entender.'],
    ['demo-06', 'GRUPO 6', 'A jornada começa antes da venda e continua depois da entrega.'],
    ['demo-07', 'GRUPO 7', 'Conhecer o produto permite transformar informação em solução.'],
    ['demo-08', 'GRUPO 8', 'Todos os pontos de contato constroem juntos a percepção da marca.']
].map(([id, grupo, texto]) => Object.freeze({ id, grupo, texto })));
